export default {
    book: "Резервирај {product}",
    age_limit: "Само за лица над {age} години",
    change_plan: "Промени план",
    upgrade_product: "Подобри продукт",
    upgrade: "Подобри",
    cancel_upgrade: "Откажи подобрување",
    choose_product: "Избери {product}",
    days: "{count} ден | {count} дена",
    login_register: "Најава/Регистрација",
    current: "Моментален",
    keyless_benefits: {
        label: 'Директно до автомобилот {0}',
        highlight: 'продавница™',
        list: {
            cant_lose_the_key: 'Полна застраховка',
            zero_excess: 'Нула вишок',
            phone_as_a_key: 'Телефон како клуч',
            straight_to_car: 'Без чекање',
            no_queues: 'Нема редови',
            online_id_check: 'Онлајн проверка на идентитет',
            self_checkout: 'Самопослужување',
        },
    },
}
